import uiScreenshotUrl01 from '../../assets/images/ui_screenshots/ui_screenshot-01.jpg';
import uiScreenshotUrl02 from '../../assets/images/ui_screenshots/ui_screenshot-02.jpg';
import uiScreenshotUrl03 from '../../assets/images/ui_screenshots/ui_screenshot-03.jpg';
import uiScreenshotUrl04 from '../../assets/images/ui_screenshots/ui_screenshot-04.jpg';
import uiScreenshotUrl05 from '../../assets/images/ui_screenshots/ui_screenshot-05.jpg';
import uiScreenshotUrl06 from '../../assets/images/ui_screenshots/ui_screenshot-06.jpg';
import uiScreenshotUrl07 from '../../assets/images/ui_screenshots/ui_screenshot-07.jpg';
import uiScreenshotUrl08 from '../../assets/images/ui_screenshots/ui_screenshot-08.jpg';

import hpLinkCsLiveUrl from '../../assets/images/hp_links/hp-link-cs-live.jpg';
import hpLinkEBookUrl from '../../assets/images/hp_links/hp-link-ebook.jpg';
import hpLinkRtmBlogUrl from '../../assets/images/hp_links/hp-link-rtm-blog.jpg';
import hpLinkRtmWhitepaperUrl from '../../assets/images/hp_links/hp-link-rtm-whitepaper.jpg';

import { HomePageLinksSectionItem, UiScreenshot } from './homepage.types';

export const UiScreenshots: UiScreenshot[] = [
  {
    imageUrl: uiScreenshotUrl01,
    productLabel: 'CityStream™ Live Feed',
  },
  {
    imageUrl: uiScreenshotUrl02,
    productLabel: 'CityStream™ Live Feed',
  },
  {
    imageUrl: uiScreenshotUrl03,
    productLabel: 'CityStream™ Road Inventory',
  },
  {
    imageUrl: uiScreenshotUrl04,
    productLabel: 'CityStream™ Road Inventory',
  },
  {
    imageUrl: uiScreenshotUrl05,
    productLabel: 'CityStream™ Virtual Camera',
  },
  {
    imageUrl: uiScreenshotUrl06,
    productLabel: 'CityStream™ Virtual Camera',
  }, 
  {
    imageUrl: uiScreenshotUrl07,
    productLabel: 'CityStream™ Work Zones',
  },
  {
    imageUrl: uiScreenshotUrl08,
    productLabel: 'CityStream™ Work Zones',
  },
];

export const HomePageLinksSectionItems: HomePageLinksSectionItem[] = [
  {
    label: 'Introducing: CityStream™ Live',
    href: 'https://mapping.getnexar.com/',
    cta: 'Visit Website',
    imageUrl: hpLinkCsLiveUrl,
  },

  {
    label: "How Nexar's<br />Real-Time Mapping enables all vehicles to<br />see all roads",
    href: 'https://info.getnexar.com/rtm-whitepaper-nexar',
    cta: 'Read Whitepaper',
    imageUrl: hpLinkRtmWhitepaperUrl,
  },
  {
    label: "CityStream™ Live's<br />Real-Time Mapping Platform has<br />Kickstarted a Revolution.<br />Here's Why",
    href: 'https://data.getnexar.com/blog/citystream-lives-real-time-mapping-platform-has-kickstarted-a-revolution-heres-why/',
    cta: 'Go to Blog',
    imageUrl: hpLinkRtmBlogUrl,
  },
  {
    label: 'Getting Camera Data Out of the Car and Into the World',
    href: 'https://info.getnexar.com/crowd-sourced-vision-ebook-nexar-automotive-',
    cta: 'Get eBook',
    imageUrl: hpLinkEBookUrl,
  },
];
